"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setIcon = function setIcon(active, done, error) {
  if (done) {
    return {
      icon: 'fa-check-circle',
      color: 'green'
    };
  } else if (active && !done) {
    return {
      icon: 'fa-dot-circle-o',
      color: 'black'
    };
  } else if (error) {
    return {
      icon: 'fa-exclamation-circle',
      color: 'red'
    };
  } else {
    return {
      icon: 'fa-clock-o',
      color: 'inactive'
    };
  }
};

var ProgressIndicatorStepIcon = function ProgressIndicatorStepIcon(props) {
  var iconObj = setIcon(props.isActive, props.isDone, props.isError);
  return _react.default.createElement("div", {
    className: "step-indicator__step--icon"
  }, _react.default.createElement("i", {
    className: "fa ".concat(iconObj.icon, " ").concat(iconObj.color),
    "aria-hidden": "true"
  }));
};

var ProgressIndicatorStep = function ProgressIndicatorStep(props) {
  var lightGray = !props.isDone && !props.isActive ? 'light-gray-color' : '';
  var bold = props.isActive ? 'bold' : '';
  var isLink = props.isLink && props.linkAddress ? _react.default.createElement("a", {
    href: props.linkAddress,
    className: "regular-link-text ".concat(lightGray, " ").concat(bold)
  }, props.status) : _react.default.createElement("p", {
    className: "regular-body-text ".concat(lightGray, " ").concat(bold)
  }, props.status);
  return _react.default.createElement("li", {
    className: "step-indicator__step ".concat(props.colSize)
  }, _react.default.createElement(ProgressIndicatorStepIcon, {
    isActive: props.isActive,
    isDone: props.isDone,
    isError: props.isError || false
  }), _react.default.createElement("div", {
    className: "step-indicator__step--details"
  }, isLink, props.line1 && _react.default.createElement("span", {
    className: "small-body-text ".concat(lightGray)
  }, props.line1), props.line2 && _react.default.createElement("span", {
    className: "small-body-text ".concat(lightGray)
  }, props.line2)));
};

var ProgressIndicator =
/*#__PURE__*/
function (_Component) {
  _inherits(ProgressIndicator, _Component);

  function ProgressIndicator() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ProgressIndicator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ProgressIndicator)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "getColumnSize", function () {
      if (_this.props.data.length === 1) {
        return 'col-100';
      } else if (_this.props.data.length === 2) {
        return 'col-50';
      } else if (_this.props.data.length === 3) {
        return 'col-30';
      } else if (_this.props.data.length === 4) {
        return 'col-25';
      } else if (_this.props.data.length > 4) {
        return 'col-20';
      } else if (_this.props.data.length > 6) {
        return 'col-10';
      } else {
        return 'col-10';
      }
    });

    return _this;
  }

  _createClass(ProgressIndicator, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement("div", {
        className: "step-indicator grid-wrapper"
      }, _react.default.createElement("ul", {
        className: "step-indicator__progressbar"
      }, this.props.data.map(function (step, i) {
        return _react.default.createElement(ProgressIndicatorStep, {
          key: i,
          isActive: step.isActive,
          isDone: step.done,
          isError: step.isError,
          status: step.status,
          colSize: _this2.getColumnSize(),
          line1: step.line1,
          line2: step.line2,
          isLink: step.isLink,
          linkAddress: step.linkAddress
        });
      })));
    }
  }]);

  return ProgressIndicator;
}(_react.Component);

var _default = ProgressIndicator;
exports.default = _default;